import {ESLNoteIgnore} from '@exadel/esl';

export class HpeNoteIgnore extends ESLNoteIgnore {
  static override is = 'hpe-note-ignore';
  protected override noteTag = 'hpe-note';
}
